import React from "react";

const Tokenomics = () =>{
    return(
        <>
        <div className="tokenomics">
        <div className="bgColorDiv"> 
                    <div className ="bgColor"></div>
                    <div className="bgColor2"></div>
        </div>
        <div className="hTokenomics">
            TOKENOMICS
        </div>
        <div className="liquidity">Liquidity <br/><span>Locked</span></div>
        <div className="contract">contract <br/><span>renounced</span></div>
        <div className="taxes">Taxes <br/><span>0%</span></div>
        <div className="imgDiv">
            <img alt="img1" className="img1" src="/Image/DALL·E 2024-07-23 00.50.44 - A 3D cartoon illustration of a furry Central Asian Shepherd Alabay dog with big eyes, wearing a cap with a dollar logo on its head and counting money_ 1.png" />
            <div className="imgShadowDiv">
                <img alt="img1" className="img1" src="/Image/DALL·E 2024-07-23 00.50.44 - A 3D cartoon illustration of a furry Central Asian Shepherd Alabay dog with big eyes, wearing a cap with a dollar logo on its head and counting money_ 1.png" />
            </div>
            </div>
        </div>
        </>
    )
}

export default Tokenomics;
